import React from 'react';
import ReactDOM from 'react-dom';
import './SubscriptionCard.css';

function parseDate(str) {
    if (!str) return null;
    const [d, m, y] = str.split('/');
    return new Date(y, m - 1, d);
}

function diffDays(a, b) {
    return Math.round((b - a) / 86400000);
}

function getStatus(endDateStr) {
    const end = parseDate(endDateStr);
    if (!end) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const remaining = diffDays(today, end);
    if (remaining < 0)  return { label: 'Expirada',        color: '#e53935', bg: '#fff1f1', icon: '✕' };
    if (remaining <= 30) return { label: 'Expirando em breve', color: '#e67e22', bg: '#fff8f0', icon: '⚠' };
    return              { label: 'Ativa',               color: '#27ae60', bg: '#f0faf4', icon: '✓' };
}

class SubscriptionCard extends React.Component {
    render() {
        const { subscription } = this.props;

        if (!subscription) {
            return (
                <div className="sub-card sub-card--empty">
                    <div className="sub-card__eyebrow">Assinatura</div>
                    <div className="sub-card__empty-msg">
                        <span className="sub-card__empty-icon">◌</span>
                        <p>Nenhuma assinatura encontrada</p>
                        <button
                            className="sub-card__btn sub-card__btn--primary"
                            data-toggle="modal"
                            data-target="#createAssinatura"
                        >
                            Criar Assinatura
                        </button>
                    </div>
                </div>
            );
        }

        const { id, start_at, end_at, end_at_raw } = subscription;
        const status   = getStatus(end_at);
        const startDt  = parseDate(start_at);
        const endDt    = parseDate(end_at);
        const total    = startDt && endDt ? diffDays(startDt, endDt) : 0;
        const today    = new Date(); today.setHours(0,0,0,0);
        const elapsed  = startDt ? Math.max(0, Math.min(total, diffDays(startDt, today))) : 0;
        const pct      = total > 0 ? Math.round((elapsed / total) * 100) : 0;
        const remaining = endDt ? diffDays(today, endDt) : 0;

        return (
            <div className="sub-card">
                <div className="sub-card__header">
                    <div>
                        <div className="sub-card__eyebrow">Assinatura</div>
                        <div className="sub-card__id">#{id}</div>
                    </div>
                    {status && (
                        <span className="sub-card__badge" style={{ color: status.color, background: status.bg }}>
                            <span className="sub-card__badge-icon">{status.icon}</span>
                            {status.label}
                        </span>
                    )}
                </div>

                <div className="sub-card__dates">
                    <div className="sub-card__date-block">
                        <span className="sub-card__date-label">Início</span>
                        <span className="sub-card__date-value">{start_at}</span>
                    </div>
                    <div className="sub-card__date-sep">→</div>
                    <div className="sub-card__date-block sub-card__date-block--end">
                        <span className="sub-card__date-label">Expiração</span>
                        <span className="sub-card__date-value">{end_at}</span>
                    </div>
                </div>

                <div className="sub-card__progress-wrap">
                    <div className="sub-card__progress-labels">
                        <span>Progresso</span>
                        <span>
                            {remaining >= 0
                                ? `${remaining} dia${remaining !== 1 ? 's' : ''} restante${remaining !== 1 ? 's' : ''}`
                                : `Expirada há ${Math.abs(remaining)} dia${Math.abs(remaining) !== 1 ? 's' : ''}`
                            }
                        </span>
                    </div>
                    <div className="sub-card__progress-track">
                        <div
                            className="sub-card__progress-fill"
                            style={{
                                width:      `${pct}%`,
                                background: status ? status.color : '#5B595B',
                            }}
                        />
                    </div>
                    <div className="sub-card__progress-pct">{pct}% utilizado</div>
                </div>

                <div className="sub-card__footer">
                    <button
                        className="sub-card__btn sub-card__btn--secondary"
                        data-toggle="modal"
                        data-target="#createAssinatura"
                    >
                        Nova assinatura
                    </button>
                    <button
                        className="sub-card__btn sub-card__btn--primary"
                        data-toggle="modal"
                        data-target="#exampleModal"
                    >
                        Editar
                    </button>
                </div>
            </div>
        );
    }
}

const mountPoint = document.getElementById('js-subscription-card');
if (mountPoint) {
    const subscription = JSON.parse(mountPoint.dataset.subscription || 'null');
    ReactDOM.render(<SubscriptionCard subscription={subscription} />, mountPoint);
}
